<template>
    <div class="wapper">
        <swiper class="swiper" :options="swiperOption">
            <swiper-slide class="swiper-item swiper-slide-active">
                <div class="swiper-wapper">
                    <img src="../../assets/img/home/banner-bg2.jpg" alt="">
                    <div class="index-ban-txt">
                        <h1>网根科技</h1>
                        <p>MPA联合体实体化运营机构</p>
                        <a href="/NetRootBJ">了解网根北京</a>
                        <a href="/NetRootQD">了解网根青岛</a>
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide class="swiper-item swiper-slide-active">
                <div class="swiper-wapper">
                    <img src="../../assets/img/home/banner-bg1.jpg" alt="">
                    <div class="index-ban-txt">
                        <h1>MPA联合体</h1>
                        <p>立足中国、服务亚大、面向世界</p>
                        <router-link to="/MPAIntr">查看详情</router-link>
                    </div>
                </div>
            </swiper-slide>
             <swiper-slide class="swiper-item swiper-slide-active">
                <div class="swiper-wapper">
                    <img src="../../assets/img/home/DOA-banner.jpg" alt="">
                    <div class="index-ban-txt">
                        <h1>DOA/Handle</h1>
                        <h1 class="twoTitle">数字对象体系架构与数据空间基础技术</h1>
                        <p>数据要素跨网、跨域、跨系统流通，新型数据基础设施关键技术</p>
                        <a href="/DOAintroduce">了解DOA</a>
                    </div>
                </div>
            </swiper-slide>
             <!-- <swiper-slide class="swiper-item swiper-slide-active">
                <div class="swiper-wapper">
                    <img src="../../assets/img/home/banner-bg4.jpg" alt="">
                    <div class="index-ban-txt">
                        <h1>行业/领域节点</h1>
                        <p>利用Handle技术搭建Handle 服务平台，为各个行业提供行业/领域节点基础服务能力，在确保数据主权的前提下通过统一的Handle服务平台对外提供服务。</p>
                        <a href="/Field-Node">查看详情</a>
                    </div>
                </div>
            </swiper-slide> -->
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>
    </div>
</template>

<script>
export default {
  name: 'CarouselBanner',
  data () {
    return {
      swiperOption: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wapper{
    width: 100%;
    height:0;
    overflow: hidden;
    padding-bottom: 29%;
    background-color: #1e1939;
    /deep/.swiper-pagination-bullet-active{
            background-color: #fff;
    }
    /deep/.swiper-pagination-bullet{
        width: 20px;
        height: 4px;
        border-radius: 10%;
        background: #fff;
    }
    /deep/.swiper-pagination-fraction,
     .swiper-pagination-custom,
     .swiper-container-horizontal > .swiper-pagination-bullets{
        bottom:18.69%
    }
    .swiper-container{
        top: 124px;
        .swiper-wapper{
            position: relative;
            top:0;
            left: 0;
            img{
                width: 100%;
                height: auto;
            }
            .index-ban-txt{
                width: 560px;
                position: absolute;
                top:50%;
                left: 50%;
                margin: -152px 0 0 -500px;
                color: #fff;
                h1 {
                    font-size: 38px;
                    margin:0;
                }
                h1.twoTitle{
                    font-size:25px;
                }
                p {
                    font-size: 16px;
                    line-height: 1.8;
                }
                a {
                    display: inline-block;
                    vertical-align: middle;
                    margin-top: 50px;
                    width: 170px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 16px;
                    color: #fff;
                    background-color: #0984e3;
                }
            }
        }
        .swiper-slide-active .index-ban-txt h1,
        .swiper-slide-active .index-ban-txt p,
        .swiper-slide-active .index-ban-txt a{
            animation: fadeInUp .8s .5s ease-out both
        }
        .swiper-slide-active .index-ban-txt p {
            animation-delay: .6s;
        }
        .swiper-slide-active .index-ban-txt a {
            animation-delay: .7s;
        }

        @keyframes fadeInUp{
            0% {
                transform: translateY(60px);
                opacity: 0;
            }
            100% {
                transform: translateY(0);
                opacity: 1;
            }
        }
    }
}

@media screen and (max-width: 1000px) {
.wapper{
    height:100%;
    .swiper-wapper{
        height:144px;
        .index-ban-txt {
            width:100% !important;
            top: 0 !important;
            left: 0 !important;
            margin:0 !important;
            h1{
                font-size: 20px !important;
                margin: 0 !important;
            }
            p{
                font-size: 12px !important;
                line-height: 1.8 !important;
            }
            a{
                margin-top: 12px !important;
                width: 86px !important;
                height: 28px !important;
                line-height: 28px !important;
                font-size: 12px !important;
                border-radius: 5px !important;
            }
        }
    }
}
}
</style>



// WEBPACK FOOTER //
// src/Home/components/CarouselBanner.vue